"use client";

import { appStoreUrl, playStoreUrl } from "@/components/footer/social-links";
import { Smartphone } from "lucide-react";
import { useEffect, useState } from "react";
import { PromotionalCardBase } from "../card-base";
import { PromotionalCardProps } from "../types";

export function DownloadAppCard({ className }: PromotionalCardProps) {
	const [link, setLink] = useState<string | null>(null);
	const [label, setLabel] = useState("Download App");

	useEffect(() => {
		const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;

		if (/android/i.test(userAgent)) {
			setLink(playStoreUrl);
			setLabel("Get it on Google Play");
		} else if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream) {
			setLink(appStoreUrl);
			setLabel("Download on App Store");
		}
	}, []);

	return (
		<PromotionalCardBase
			icon={<Smartphone className="w-full h-full" strokeWidth={1.5} />}
			title="Experience Better on App"
			description="Get smoother browsing, instant alerts & exclusive features"
			ctaText={link ? label : undefined}
			href={link || undefined}
			isExternal
			className={className}
		>
			{!link && (
				<div className="flex gap-3 text-xs font-medium text-primary-600 mt-1">
					<a href={appStoreUrl} target="_blank" rel="noopener noreferrer" className="hover:underline">
						App Store
					</a>
					<span className="text-gray-300">|</span>
					<a href={playStoreUrl} target="_blank" rel="noopener noreferrer" className="hover:underline">
						Google Play
					</a>
				</div>
			)}
		</PromotionalCardBase>
	);
}
